"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinPeerSources = void 0;
const shuffling_1 = require("../../../../util/shuffling");
var JoinMode;
(function (JoinMode) {
    JoinMode["interleave"] = "interleave";
    JoinMode["eager"] = "eager";
    JoinMode["random"] = "random";
})(JoinMode || (JoinMode = {}));
;
class JoinPeerSources {
    constructor(sources, mode = JoinMode.interleave) {
        this.sources = sources;
        this.mode = mode;
    }
    async getPeers(count) {
        let allPIs = [];
        let total = 0;
        let toFetch = count;
        for (const source of this.sources) {
            let pi = await source.getPeers(toFetch);
            allPIs.push(pi);
            total = total + pi.length;
            if (this.mode === JoinMode.eager) {
                toFetch = toFetch - pi.length;
                if (toFetch === 0) {
                    break;
                }
            }
        }
        let result = [];
        if (this.mode === JoinMode.interleave) {
            while (total > 0 && result.length < count) {
                for (const pis of allPIs) {
                    if (pis.length > 0 && result.length < count) {
                        let pi = pis.pop();
                        total = total - 1;
                        result.push(pi);
                    }
                }
            }
        }
        else if (this.mode === JoinMode.random) {
            let all = [];
            for (const pis of allPIs) {
                all = all.concat(pis);
            }
            shuffling_1.Shuffle.array(all);
            result = all.slice(0, count);
        }
        else if (this.mode === JoinMode.eager) {
            for (const pis of allPIs) {
                result = result.concat(pis);
            }
        }
        return result;
    }
    async getPeerForEndpoint(endpoint) {
        for (const source of this.sources) {
            let pi = await source.getPeerForEndpoint(endpoint);
            if (pi !== undefined) {
                return pi;
            }
        }
        return undefined;
    }
}
exports.JoinPeerSources = JoinPeerSources;
//# sourceMappingURL=JoinPeerSources.js.map